import Vue from 'vue'
import VueRouter from 'vue-router'
import qs from 'qs'
import store from '@/modules/store'
import { EventBus } from '@/modules/plugins/modules/event'
import routes from './routes'
import scrollBehavior from './scrollBehavior'

const LIST_VIEW = ['restaurant-list']
const HIGHLIGHTED_LIST_VIEW = ['featured-restaurant-list', 'popular-restaurant-list']
const RESTAURANT_VIEW = ['restaurant', 'restaurant-canteen']
const BRAND_VIEW = ['brand-list']
const CHECKOUT_VIEW = ['checkout']

Vue.use(VueRouter)
const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_BASE_URL,
    scrollBehavior: scrollBehavior,
    parseQuery: (query) => {
        return qs.parse(query)
    },
    stringifyQuery: (query) => {
        let result = qs.stringify(query, {
            encode: false,
            arrayFormat: 'brackets',
        })
        return result ? '?' + result : ''
    },
    routes,
})

router.beforeEach(async (to, from, next) => {
    // Check view
    store.dispatch('site/listView', LIST_VIEW.includes(to.name))
    store.dispatch('site/highlightedListView', HIGHLIGHTED_LIST_VIEW.includes(to.name))
    store.dispatch('site/restaurantView', RESTAURANT_VIEW.includes(to.name))
    store.dispatch('site/brandView', BRAND_VIEW.includes(to.name))
    store.dispatch('site/checkoutView', CHECKOUT_VIEW.includes(to.name))

    // Loading start
    if (
        !to.meta.loaderPage &&
        !(
            to.name === from.name &&
            (LIST_VIEW.includes(to.name) || RESTAURANT_VIEW.includes(to.name))
        )
    ) {
        store.dispatch('loading/start')
    }

    // Check guards
    if (to.matched.some((route) => route.meta.requiresAuth) && !Vue.prototype.$user.isLoggedIn) {
        EventBus.$emit('closeAllModals')
        store.dispatch('loading/finish')
        if (process.env.NODE_ENV === 'development')
            store.dispatch('toastInfo', {
                title: 'Permission denied',
                text: 'Please log in or contact the system administrator.',
            })
        next({ name: 'restaurant-list' })
        return
    }

    if (process.env.NODE_ENV === 'production' && to.hash === '#livechat' && !to.meta.loaderPage) {
        Vue.prototype.$intercom?.show()
    }

    if (to.name !== from.name && !from.meta.loaderPage) EventBus.$emit('closeAllModals')

    // Exit from order in progress
    if (!to.meta.orderInProgress && from.meta.orderInProgress) {
        store.dispatch('active/resetRestaurant')
        store.dispatch('active/resetCurrency')
    }

    // if only Cloud Canteen enabled for the user (because company policy) & the reached page not in scope
    // => navigate the user to the Canteen pickup page
    if (Vue.prototype.$user.onlyCloudCanteen && !to.meta.scope?.companyCanteen) {
        next({ name: 'canteen-pickup' })
        return
    }

    // If the user is in canteen mode and the following page is not in the canteen scope => get confirmation
    if (
        (store.getters['active/canteen']?.id || Vue.prototype.$cart.isCloudCanteen) &&
        !to.meta.scope?.canteen &&
        from.meta.scope?.canteen &&
        to.name !== 'summary-page' //expcept summary page
    ) {
        try {
            await store.dispatch('canteen/leavingScope')
            next()
            return
        } catch {
            next(false)
            return
        }
    }
    next()
    return
})

router.afterEach((to, from) => {
    // Loading end
    store.dispatch('loading/finish')
    if (to.name !== from.name || to.params?.page !== from.params?.page)
        Vue.nextTick(() => {
            EventBus.$emit('finally')
        })

    // If the user is in canteen mode and the following page is not in the canteen scope => reset
    if (
        (store.getters['active/canteen']?.id || Vue.prototype.$cart.isCloudCanteen) &&
        !to.meta.scope?.canteen
    ) {
        store.dispatch('active/resetCanteen')
        Vue.prototype.$cart.resetCart()
        Vue.prototype.$cart.resetTemporary()
        Vue.prototype.$cart.address = store.getters['order/address']
    }
})

export default router
